var map = {
	"./de/text-steam.png": "RS2F",
	"./en/text-steam.png": "ilXo",
	"./es/text-steam.png": "mQ1h",
	"./fr/text-steam.png": "M+4S",
	"./ja/text-steam.png": "6DJe",
	"./ko/text-steam.png": "X8fo",
	"./pt/text-steam.png": "sQpz",
	"./ru/text-steam.png": "JWhV",
	"./th/text-steam.png": "Fwen",
	"./zh-Hant/text-steam.png": "jmif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SVox";